// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZO3ml","newExpiryDate":"styles_newExpiryDate__3vF0c","footer":"styles_footer__urIOT"};